var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Services")]),_c('b-breadcrumb',{staticClass:"p-0",attrs:{"items":_vm.items}}),_c('b-card',[_vm._v(" Services, ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }